import React from "react";
import styled from "styled-components";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import GitHubIcon from "@mui/icons-material/GitHub";
import { Bio } from "../../data/constants";

const Section = styled.section`
  padding: 120px 20px 100px 20px;
  text-align: center;
  background: ${({ theme }) => theme.bg};
`;

const Title = styled.h2`
  font-size: 56px;
  font-weight: 700;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text_primary};

  @media (max-width: 768px) {
    font-size: 38px;
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  color: ${({ theme }) => theme.text_secondary};
  max-width: 600px;
  margin: 0 auto 40px auto;
`;

const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 25px;
  flex-wrap: wrap;
`;

const IconWrapper = styled.a`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1.5px solid rgba(147, 51, 234, 0.35); /* Purple border */
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.text_primary};
  font-size: 32px;
  transition: 0.35s ease;
  text-decoration: none;

  &:hover {
    transform: translateY(-6px) scale(1.12);
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 18px rgba(147, 51, 234, 0.45);
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }
`;

const Contact = () => {
  return (
    <Section id="Contact">
      <Title>Contact</Title>

      <Subtitle>
        Feel free to reach out through any of the platforms below.
      </Subtitle>

      <IconsContainer>
        <IconWrapper href={Bio.email} target="_blank" aria-label="Send Email">
          <EmailIcon fontSize="inherit" />
        </IconWrapper>

        <IconWrapper href={Bio.linkedin} target="_blank" aria-label="LinkedIn Profile">
          <LinkedInIcon fontSize="inherit" />
        </IconWrapper>

        <IconWrapper href={Bio.Whatsapp} target="_blank" aria-label="WhatsApp Contact">
          <WhatsAppIcon fontSize="inherit" />
        </IconWrapper>

        <IconWrapper href={Bio.github} target="_blank" aria-label="GitHub Profile">
          <GitHubIcon fontSize="inherit" />
        </IconWrapper>
      </IconsContainer>
    </Section>
  );
};

export default Contact;
